import React from 'react'

class TarifarioAgencia extends React.Component {

    render() {

        return (
              <div>
                  <p>TarifarioAgencia</p>
              </div>
                );
    }
}

export default TarifarioAgencia



// WEBPACK FOOTER //
// ./src/components/TarifarioAgencia/index.js